// In CustomerInfoPanel.jsx
import React, { useState } from "react";
import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import NoCustomerSelected from "./NoCustomerSelected";
import { blue } from "@mui/material/colors";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import DeleteSweepOutlinedIcon from "@mui/icons-material/DeleteSweepOutlined";
import { BorderedStack } from "../../../styled/pos/superficies";
import { useDispatch, useSelector } from "react-redux";
import FormCustomer from "./form/FormCustomer";
import { setCustomer } from "../../../../store/actions/newOrderSlice";
import CustomConfirmationDialog from "../../../dialogs/CustomConfirmationDialog";

const CustomerInfoPanel = () => {
  const dispatch = useDispatch();
  const customer = useSelector((state) => state.newOrder.customer);
  const showCustomerForm = useSelector(
    (state) => state.newOrder.showCustomerForm
  );
  const [openDialog, setOpenDialog] = useState(false);

  const handleRemoveCustomer = () => {
    dispatch(setCustomer(null));
  };

  return (
    <>
      <BorderedStack paddingX={2} paddingY={2}>
        {!showCustomerForm && !customer && <NoCustomerSelected />}

        {showCustomerForm && <FormCustomer />}

        {!showCustomerForm && customer && (
          <>
            <Box sx={{ display: "flex", justifyContent: "start" }}>
              <Avatar sx={{ bgcolor: blue[400] }}>
                {customer.name[0]}
                {customer.name[1]}
              </Avatar>
              <Stack sx={{ ml: 2 }}>
                <Typography variant={"body1"}>{customer.name}</Typography>
                <Typography variant={"caption"}>
                  18 pedidos no restaurante
                </Typography>
              </Stack>
            </Box>
            <Box
              sx={{
                mt: 1,
                display: "flex",
                justifyContent: "end",
                flexWrap: "wrap",
                gap: 1,
              }}
            >
              <Chip
                icon={<DeleteSweepOutlinedIcon />}
                label="Remover Cliente"
                color="error"
                variant="outlined"
                onClick={() => setOpenDialog(true)}
              />
            </Box>
          </>
        )}
      </BorderedStack>
      <CustomConfirmationDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onConfirm={handleRemoveCustomer}
        title="Remover Cliente"
        dialogContent="Tem certeza que deseja remover o cliente do pedido?"
        confirmText="Remover"
        cancelText="Cancelar"
      />
    </>
  );
};

export default CustomerInfoPanel;
